import useOnClickPrepareSoundAnnotation from './useOnClickPrepareSoundAnnotation';

export default useOnClickPrepareSoundAnnotation;